/*
 * Behaviour for the product.otcd-v3 template (otcd-pdp-* sections).
 * Handlers are delegated from document so they survive theme-editor re-renders.
 *  - quantity stepper and media thumbnails
 *  - main image lightbox (native <dialog>)
 *  - related products sidebar (product recommendations, section otcd-pdp-related)
 *  - quote fallback dedupe (Samita Request for Quote injects its own button)
 *  - sticky offset below the theme's always-sticky header
 *  - ARIA tabs, jump links and #hash deep links
 *  - endorsement disclosure toggles
 *  - copy specs for a submittal
 *  - click-to-load YouTube facade (youtube-nocookie.com)
 */
(function () {
  'use strict';

  if (window.otcdPdpLoaded) return;
  window.otcdPdpLoaded = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* Quantity stepper ------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-otcd-pdp-qty]');
    if (!button) return;
    var input = button.parentElement.querySelector('[data-otcd-pdp-qty-input]');
    if (!input) return;
    var min = parseInt(input.min, 10) || 1;
    var max = parseInt(input.max, 10) || Infinity;
    var step = parseInt(input.step, 10) || 1;
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = min;
    value += step * parseInt(button.getAttribute('data-otcd-pdp-qty'), 10);
    input.value = Math.min(max, Math.max(min, value));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Media thumbnails ------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-otcd-pdp-thumb]');
    if (!thumb) return;
    var gallery = thumb.closest('[data-otcd-pdp-gallery]');
    var main = gallery && gallery.querySelector('[data-otcd-pdp-gallery-main] img');
    if (!main) return;
    main.src = thumb.getAttribute('data-full');
    main.removeAttribute('srcset');
    main.alt = thumb.getAttribute('data-alt') || '';
    var zoom = gallery.querySelector('[data-otcd-pdp-zoom]');
    if (zoom && thumb.getAttribute('data-zoom')) zoom.setAttribute('data-zoom', thumb.getAttribute('data-zoom'));
    gallery.querySelectorAll('[data-otcd-pdp-thumb]').forEach(function (node) {
      if (node === thumb) {
        node.setAttribute('aria-current', 'true');
      } else {
        node.removeAttribute('aria-current');
      }
    });
  });

  /* Main image lightbox ---------------------------------------------- */
  function lightboxShow(gallery, dialog) {
    var zoom = gallery.querySelector('[data-otcd-pdp-zoom]');
    var main = gallery.querySelector('[data-otcd-pdp-gallery-main] img');
    var img = dialog.querySelector('[data-otcd-pdp-lightbox-img]');
    if (!zoom || !img) return;
    img.src = zoom.getAttribute('data-zoom');
    img.alt = main ? main.alt : '';
  }

  document.addEventListener('click', function (event) {
    var zoom = event.target.closest('[data-otcd-pdp-zoom]');
    if (zoom) {
      var gallery = zoom.closest('[data-otcd-pdp-gallery]');
      var dialog = gallery && gallery.querySelector('[data-otcd-pdp-lightbox]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      lightboxShow(gallery, dialog);
      dialog.showModal();
      return;
    }

    var dialogEl = event.target.closest('[data-otcd-pdp-lightbox]');
    if (!dialogEl) return;

    /* Close on the close button or a click on the backdrop (outside the frame). */
    if (event.target.closest('[data-otcd-pdp-lightbox-close]') || event.target === dialogEl) {
      dialogEl.close();
      return;
    }

    var stepButton = event.target.closest('[data-otcd-pdp-lightbox-step]');
    if (!stepButton) return;
    var galleryEl = dialogEl.closest('[data-otcd-pdp-gallery]');
    var thumbs = Array.prototype.slice.call(galleryEl.querySelectorAll('[data-otcd-pdp-thumb]'));
    if (!thumbs.length) return;
    var current = thumbs.findIndex(function (node) { return node.getAttribute('aria-current') === 'true'; });
    var next = (Math.max(current, 0) + parseInt(stepButton.getAttribute('data-otcd-pdp-lightbox-step'), 10) + thumbs.length) % thumbs.length;
    thumbs[next].click(); /* keeps the page's main image and thumbnails in step */
    lightboxShow(galleryEl, dialogEl);
  });

  document.addEventListener('keydown', function (event) {
    var dialog = document.querySelector('[data-otcd-pdp-lightbox][open]');
    if (!dialog || (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight')) return;
    var button = dialog.querySelector('[data-otcd-pdp-lightbox-step="' + (event.key === 'ArrowLeft' ? '-1' : '1') + '"]');
    if (button) button.click();
  });

  /* Related products sidebar ----------------------------------------- */
  function loadRelated(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll('[data-otcd-pdp-related]'), function (aside) {
      if (aside.getAttribute('data-otcd-ready')) return;
      aside.setAttribute('data-otcd-ready', 'true');
      var url = aside.getAttribute('data-url');
      if (!url || !window.fetch) return;
      fetch(url)
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var list = doc.querySelector('[data-otcd-pdp-related-list]');
          if (!list || !list.children.length) return;
          var heading = aside.getAttribute('data-heading');
          if (heading) {
            var h2 = document.createElement('h2');
            h2.className = 'otcd-pdp__related-title';
            h2.textContent = heading;
            aside.appendChild(h2);
          }
          aside.appendChild(document.importNode(list, true));
          aside.hidden = false;
          var layout = aside.closest('.otcd-pdp__tabs-layout');
          if (layout) layout.classList.add('has-related');
        })
        .catch(function () { /* no sidebar on network errors */ });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { loadRelated(document); });
  } else {
    loadRelated(document);
  }
  document.addEventListener('shopify:section:load', function (event) { loadRelated(event.target); });

  /* Quote fallback dedupe -------------------------------------------- */
  function dedupeQuote() {
    var appPresent =
      document.querySelector('.otcd-pdp .rfq-btn, .otcd-pdp .rfq-product-form, .otcd-pdp [id^="rfq-btn"]') !== null ||
      Array.prototype.some.call(document.querySelectorAll('.otcd-pdp .g-product-atc'), function (hook) {
        return hook.children.length > 0;
      });
    if (!appPresent) return false;
    document.querySelectorAll('.otcd-pdp__quote-fallback').forEach(function (node) {
      node.classList.add('is-superseded');
    });
    return true;
  }

  // The sticky bar's quote button stays visible and hands off to the app's
  // own button, so there is still a single quote handler on the page.
  document.addEventListener('click', function (event) {
    var sticky = event.target.closest('.otcd-pdp__sticky-quote');
    if (!sticky) return;
    var appButton = document.querySelector('.otcd-pdp__form .rfq-btn');
    if (!appButton) return;
    event.preventDefault();
    appButton.click();
  });

  function watchForQuoteApp() {
    if (!document.querySelector('.otcd-pdp__quote-fallback') || dedupeQuote()) return;
    var observer = new MutationObserver(function () {
      if (dedupeQuote()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }

  /* Sticky offset: the theme header is always sticky ------------------ */
  function trackHeader() {
    var header = document.querySelector('.shopify-section-header');
    if (!header || !('ResizeObserver' in window)) return;
    var update = function () {
      document.documentElement.style.setProperty('--otcd-pdp-sticky-top', header.offsetHeight + 'px');
    };
    new ResizeObserver(update).observe(header);
    update();
  }

  /* Tabs --------------------------------------------------------------- */
  function tabsFor(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
  }

  function scrollToTabs(root) {
    var bar = root.querySelector('[data-otcd-pdp-tablist-bar]') || root;
    var top = bar.getBoundingClientRect().top + window.pageYOffset;
    var offset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--otcd-pdp-sticky-top')) || 0;
    window.scrollTo({ top: Math.max(0, top - offset), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
  }

  function selectTab(root, panelId, options) {
    options = options || {};
    var tabs = tabsFor(root);
    var target = document.getElementById(panelId);
    if (!target || !root.contains(target)) return false;

    if (tabs.length) {
      var match = tabs.some(function (tab) {
        return tab.getAttribute('aria-controls') === panelId;
      });
      if (!match) return false;
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('aria-controls') === panelId;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
        if (on && options.focus) tab.focus();
      });
    }

    if (options.scroll) scrollToTabs(root);
    if (options.updateHash) {
      try {
        history.replaceState(null, '', '#' + panelId);
      } catch (error) {
        /* ignore: replaceState can be blocked in sandboxed previews */
      }
    }
    return true;
  }

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('.otcd-pdp [role="tab"]');
    if (tab) {
      selectTab(tab.closest('[data-otcd-pdp-tabs]'), tab.getAttribute('aria-controls'), { updateHash: true });
      return;
    }

    var jump = event.target.closest('[data-otcd-pdp-tab-link]');
    if (!jump) return;
    var root = document.querySelector('[data-otcd-pdp-tabs]');
    if (!root) return;
    if (selectTab(root, jump.getAttribute('data-otcd-pdp-tab-link'), { scroll: true, updateHash: true })) {
      event.preventDefault();
    }
  });

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('.otcd-pdp [role="tab"]');
    if (!tab) return;
    var root = tab.closest('[data-otcd-pdp-tabs]');
    var tabs = tabsFor(root);
    var index = tabs.indexOf(tab);
    var next = null;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;
    if (next === null) return;
    event.preventDefault();
    selectTab(root, tabs[next].getAttribute('aria-controls'), { focus: true, updateHash: true });
  });

  function applyHash() {
    var id = (window.location.hash || '').slice(1);
    if (!id) return;
    var root = document.querySelector('[data-otcd-pdp-tabs]');
    if (root) selectTab(root, id, { scroll: true });
  }

  window.addEventListener('hashchange', applyHash);

  /* Endorsement disclosures ------------------------------------------- */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-otcd-pdp-disclosure]');
    if (!toggle) return;
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.hidden = !open;
  });

  /* Copy specs ---------------------------------------------------------- */
  function specsText(panel) {
    var root = panel.closest('[data-otcd-pdp-tabs]');
    var title = (root && root.getAttribute('data-product-title')) || '';
    var skuNode = document.querySelector('.otcd-pdp [id^="Sku-"] span');
    var sku = skuNode ? skuNode.textContent.trim() : '';
    var lines = [title + (sku ? ' — SKU ' + sku : ''), '', 'Product specs:'];
    panel.querySelectorAll('[data-otcd-pdp-spec-table] tbody tr').forEach(function (row) {
      var th = row.querySelector('th');
      var td = row.querySelector('td');
      if (!td) return;
      var value = td.textContent.replace(/\s+/g, ' ').trim();
      lines.push('- ' + (th ? th.textContent.replace(/\s+/g, ' ').trim() + ': ' : '') + value);
    });
    lines.push('', 'Source: OT Cyber Direct — otcyberdirect.com — (508) 289-1195');
    return lines.join('\n');
  }

  function flash(button) {
    if (!button.hasAttribute('data-label')) button.setAttribute('data-label', button.textContent.trim());
    button.textContent = button.getAttribute('data-done-label') || 'Copied';
    clearTimeout(button._otcdTimer);
    button._otcdTimer = setTimeout(function () {
      button.textContent = button.getAttribute('data-label');
    }, 2000);
  }

  function legacyCopy(text, button) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    var copied = false;
    try {
      copied = document.execCommand('copy');
    } catch (error) {
      copied = false;
    }
    document.body.removeChild(area);
    button.focus();
    if (copied) flash(button);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-otcd-pdp-copy-specs]');
    if (!button) return;
    var panel = button.closest('[data-otcd-pdp-specs]');
    if (!panel) return;
    var text = specsText(panel);
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(
        function () {
          flash(button);
        },
        function () {
          legacyCopy(text, button);
        }
      );
    } else {
      legacyCopy(text, button);
    }
  });

  /* YouTube facade ------------------------------------------------------ */
  function youtubeId(url) {
    var match = String(url).match(/(?:youtube(?:-nocookie)?\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    return match ? match[1] : null;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-otcd-pdp-video]');
    if (!link) return;
    var id = youtubeId(link.getAttribute('href'));
    if (!id) return; // not YouTube: let the link open in a new tab
    event.preventDefault();

    var row = link.closest('[data-otcd-pdp-resource]');
    var player = row.querySelector('.otcd-pdp__res-player');
    if (!player) {
      player = document.createElement('div');
      player.className = 'otcd-pdp__res-player';
      var frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      frame.title = link.getAttribute('data-title') || 'Video';
      frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      frame.allowFullscreen = true;
      player.appendChild(frame);
      row.appendChild(player);
    }
    link.setAttribute('aria-expanded', 'true');
    player.querySelector('iframe').focus();
  });

  /* Init ------------------------------------------------------------------ */
  function init() {
    trackHeader();
    watchForQuoteApp();
    applyHash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
